import * as e from "react";
const r = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto"
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    display: "block",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "circle",
    {
      cx: 50,
      cy: 50,
      r: 32,
      strokeWidth: 8,
      stroke: "#2D6DED",
      strokeDasharray: "50.26548245743669 50.26548245743669",
      fill: "none",
      strokeLinecap: "round"
    },
    /* @__PURE__ */ e.createElement(
      "animateTransform",
      {
        attributeName: "transform",
        type: "rotate",
        repeatCount: "indefinite",
        dur: "1s",
        keyTimes: "0;1",
        values: "0 50 50;360 50 50"
      }
    )
  )
), a = r;
export {
  a as default
};
